import { supabase } from "@/lib/supabase";

/**
 * Fetch a short-lived signed URL for a pitch video directly from the
 * authenticated organizer client. The storage policy
 * `videos: organizer read meetup` grants SELECT where the caller owns
 * the event — so no Edge Function hop is needed for the dashboard.
 */
export async function getOrganizerVideoUrl(path: string): Promise<string> {
  const { data, error } = await supabase.storage
    .from("videos")
    .createSignedUrl(path, 5 * 60);
  if (error || !data) {
    throw new Error(error?.message ?? "Could not sign video URL");
  }
  return data.signedUrl;
}

/**
 * Kick off `score-meetup-matches` for a participant. Called after the
 * organizer approves a pitch so the ranked match rows are ready by the
 * time the feed becomes visible.
 */
export async function triggerMatchScoring(participantId: string): Promise<void> {
  const { error } = await supabase.functions.invoke("score-meetup-matches", {
    body: { participant_id: participantId },
  });
  if (error) {
    // Non-critical — scoring can be re-run later. Log and swallow so it
    // never blocks the approval itself.
    console.warn("score-meetup-matches failed:", error.message);
  }
}
